export enum Permission {
  MassopsView = 'massops.view',
  MassopsApprove = 'massops.approve',
}
